var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tools_btn"},[(_vm.leftIcon)?_c('svg-icon',{attrs:{"icon-class":_vm.leftIcon}}):_vm._e(),_vm._t("default"),(_vm.rightIcon)?_c('svg-icon',{attrs:{"icon-class":_vm.rightIcon}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }